export const getRequestString = (
  options: Record<string, string | string[] | number | number[] | undefined>
): string => {
  const params: string[] = [];

  Object.entries(options).forEach(([key, value]) => {
    if (typeof value === 'undefined') return;
    if (Array.isArray(value)) {
      value.forEach((val) => {
        params.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(String(val))}`
        );
      });
    } else {
      params.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
      );
    }
  });

  return params.length > 0 ? `?${params.join('&')}` : '';
};
